(function () {
  if (!window.VOLTA_CONFIG || !window.VOLTA_CONFIG.depositVariantId) {
    console.warn('VOLTA: configuração em falta.');
    return;
  }

  const VOLTA_VARIANT_ID = Number(window.VOLTA_CONFIG.depositVariantId);

  const routes = window.routes || {};
  const CART_URL = routes.cart_url || '/cart';
  const CART_ADD_URL = routes.cart_add_url || '/cart/add';
  const CART_CHANGE_URL = routes.cart_change_url || '/cart/change';

  /**
   * Delays otimizados para Aurora.
   * QUICK_SYNC_DELAY corre depois de o AJAX do carrinho terminar.
   * FALLBACK_SYNC_DELAY só serve como segurança para cliques/submits.
   */
const QUICK_SYNC_DELAY = 300;
const FALLBACK_SYNC_DELAY = 900;
const STARTUP_SYNC_DELAY = 500;
const REFRESH_UNLOCK_DELAY = 500;

  let syncing = false;
  let syncQueued = false;
  let syncTimer = null;
  let internalVoltaRequest = false;
  let refreshingAurora = false;
  let refreshQueued = false;

  const observedForms = new WeakSet();

  function toJsonUrl(url) {
    if (!url) return url;
    return url.endsWith('.js') ? url : `${url}.js`;
  }

  function getUrlFromRequest(input) {
    if (!input) return '';
    if (typeof input === 'string') return input;
    if (typeof Request !== 'undefined' && input instanceof Request) return input.url || '';
    if (input.url) return input.url;
    return '';
  }

  function isCartMutationUrl(url) {
    if (!url) return false;

    try {
      const parsedUrl = new URL(url, window.location.origin);
      return /\/cart\/(add|change|update)(\.js)?$/.test(parsedUrl.pathname);
    } catch (error) {
      return /\/cart\/(add|change|update)(\.js)?/.test(url);
    }
  }

  async function voltaFetch(url, options) {
    internalVoltaRequest = true;

    try {
      return await window.fetch(url, options);
    } finally {
      internalVoltaRequest = false;
    }
  }

  async function getCart() {
    const response = await window.fetch(toJsonUrl(CART_URL), {
      headers: {
        Accept: 'application/json'
      },
      cache: 'no-store'
    });

    if (!response.ok) {
      throw new Error('VOLTA: erro ao obter carrinho.');
    }

    return response.json();
  }

  function getExpectedVoltaUnits(cart) {
    return cart.items.reduce((total, item) => {
      if (Number(item.variant_id) === VOLTA_VARIANT_ID) return total;

      const units = Number(item.properties?._volta_units || 0);
      if (!units || units < 0) return total;

      return total + units * item.quantity;
    }, 0);
  }

  function getVoltaLine(cart) {
    return cart.items.find((item) => Number(item.variant_id) === VOLTA_VARIANT_ID);
  }

  function getAdjustedItemCount(cart) {
    return cart.items.reduce((total, item) => {
      if (Number(item.variant_id) === VOLTA_VARIANT_ID) return total;
      return total + item.quantity;
    }, 0);
  }

  function isCustomPackCartItem(item) {
    const knownIds = (window.__packConversion && window.__packConversion.productIds) || [];
    if (knownIds.some((id) => Number(id) === Number(item.product_id))) return true;

    const handle = String(item.handle || '').toLowerCase();
    const title = String(item.product_title || item.title || '').toLowerCase();
    return handle.includes('custom-pack') || title.includes('custom pack');
  }

  function getCustomPackProductIdsInCart(cart) {
    const ids = {};

    (cart.items || []).forEach((item) => {
      if (Number(item.variant_id) === VOLTA_VARIANT_ID) return;
      if (!isCustomPackCartItem(item)) return;
      ids[String(item.product_id)] = true;
    });

    return ids;
  }

  function hideRelatedProductsInCart(cart) {
    const ids = getCustomPackProductIdsInCart(cart);

    document.querySelectorAll('#CartDrawer [data-cart-drawer-related-products] [data-id]').forEach((card) => {
      const productId = card.getAttribute('data-id');
      if (!productId || !ids[productId]) return;

      const slide = card.closest(
        '.cart-drawer__on-side-related-products-slide, .cart-drawer__in-cart-related-products-slide, [slider-grid-slide]'
      );
      (slide || card).remove();
    });
  }

  function updateHeaderCartCount(cart) {
    const adjustedCount = getAdjustedItemCount(cart);
    const counts = document.querySelectorAll('#CartCount');

    counts.forEach((countEl) => {
      if (adjustedCount > 0) {
        countEl.innerHTML = `
          <div class="cart-count ${adjustedCount > 9 ? 'cart-count--ellipse' : ''}">
            <span aria-hidden="true">${adjustedCount}</span>
          </div>
        `;
      } else {
        countEl.innerHTML = '';
      }
    });
  }

  async function addVoltaLine(quantity) {
    const response = await voltaFetch(toJsonUrl(CART_ADD_URL), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: VOLTA_VARIANT_ID,
            quantity,
            properties: {
              _volta_deposit: 'true'
            }
          }
        ]
      })
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(`VOLTA: erro ao adicionar depósito. ${text}`);
    }

    return response;
  }

  async function changeVoltaLine(lineKey, quantity) {
    const response = await voltaFetch(toJsonUrl(CART_CHANGE_URL), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: lineKey,
        quantity
      })
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(`VOLTA: erro ao atualizar depósito. ${text}`);
    }

    return response;
  }

function paintVoltaLine(cart) {
  const voltaLine = getVoltaLine(cart);
  const voltaEl = document.querySelector('#CartDrawer .cart-item--volta');

  if (!voltaLine || voltaLine.quantity <= 0) {
    if (voltaEl) voltaEl.remove();
    return;
  }

  if (!voltaEl) return;

  const quantity = voltaLine.quantity;
  const meta = voltaEl.querySelector('.cart-item__volta-meta');
  if (meta) {
    meta.textContent = meta.textContent.replace(/\d+/, String(quantity));
  }

  const priceEl = voltaEl.querySelector('.cart-item__volta-price');
  if (priceEl) {
    const cents = quantity * (Number(window.VOLTA_CONFIG.rateCents) || 10);
    priceEl.textContent = `€${(cents / 100).toFixed(2).replace('.', ',')}`;
  }
}

async function refreshAuroraCartUI(force) {
  if (window.__packConverting && !force) return;

  if (refreshingAurora) {
    refreshQueued = true;
    return;
  }
  refreshingAurora = true;

  try {
    const cart = await getCart();
    updateHeaderCartCount(cart);
    paintVoltaLine(cart);

    const cartPage = document.querySelector('cart-page');
    if (cartPage) {
      window.location.reload();
      return;
    }

    const rootUrl = routes.root_url || '/';
    const refreshUrl = `${rootUrl}${rootUrl.includes('?') ? '&' : '?'}_cart=${Date.now()}`;

    const response = await window.fetch(refreshUrl, {
      headers: {
        Accept: 'text/html'
      },
      cache: 'no-store'
    });

    if (!response.ok) {
      throw new Error('VOLTA: erro ao obter HTML atualizado do carrinho.');
    }

    const htmlText = await response.text();
    const html = new DOMParser().parseFromString(htmlText, 'text/html');

    const template = html.querySelector('[data-sidebar-template="CartDrawer"]');
    const freshDrawerBody = template?.content?.firstElementChild;

    if (!freshDrawerBody) {
      throw new Error('VOLTA: não foi possível encontrar o template atualizado do CartDrawer.');
    }

    /**
     * 1. Atualizar apenas o bloco de produtos do carrinho.
     * Não mexe no footer onde apps como a Flare podem injetar campos.
     */
    document.querySelectorAll('#CartDrawer cart-drawer-items-block').forEach((currentItemsBlock) => {
      const blockId = currentItemsBlock.getAttribute('block-id');

      const freshItemsBlock = blockId
        ? freshDrawerBody.querySelector(`cart-drawer-items-block[block-id="${blockId}"]`)
        : freshDrawerBody.querySelector('cart-drawer-items-block');

      if (freshItemsBlock) {
        currentItemsBlock.innerHTML = freshItemsBlock.innerHTML;
      }
    });

    /**
     * 2. Atualizar contador escondido usado pelo Aurora.
     */
    const currentNewCartCount = document.querySelector('#CartDrawer #NewCartCount');
    const freshNewCartCount = freshDrawerBody.querySelector('#NewCartCount');

    if (currentNewCartCount && freshNewCartCount) {
      currentNewCartCount.innerHTML = freshNewCartCount.innerHTML;
    }

    /**
     * 3. Atualizar título/contagem do drawer.
     * Apenas o texto da zona do título, não o drawer completo.
     */
    const currentHeaderTitle = document.querySelector('#CartDrawer .cart-drawer__header-title');
    const freshHeaderTitle = freshDrawerBody.querySelector('.cart-drawer__header-title');

    if (currentHeaderTitle && freshHeaderTitle) {
      currentHeaderTitle.innerHTML = freshHeaderTitle.innerHTML;
    }

    /**
     * 4. Atualizar barra de portes grátis, se existir.
     */
    const currentFreeShippingBar = document.querySelector('#CartDrawer cart-drawer-free-shipping-bar-block');
    const freshFreeShippingBar = freshDrawerBody.querySelector('cart-drawer-free-shipping-bar-block');

    if (currentFreeShippingBar && freshFreeShippingBar) {
      currentFreeShippingBar.innerHTML = freshFreeShippingBar.innerHTML;
    }

    /**
     * 5. Atualizar apenas o preço total.
     * Não substituímos o footer inteiro para não apagar campos de apps.
     */
    const currentTotalPrice = document.querySelector('#CartDrawer .cart-drawer-subtotal__price');
    const freshTotalPrice = freshDrawerBody.querySelector('.cart-drawer-subtotal__price');

    if (currentTotalPrice && freshTotalPrice) {
      currentTotalPrice.innerHTML = freshTotalPrice.innerHTML;
    }

    /**
     * 6. Atualizar subtotais/descontos, se existirem.
     */
    const currentSubtotals = document.querySelector('#CartDrawer [data-subtotals]');
    const freshSubtotals = freshDrawerBody.querySelector('[data-subtotals]');

    if (currentSubtotals && freshSubtotals) {
      currentSubtotals.innerHTML = freshSubtotals.innerHTML;
    }

    /**
     * 7. Atualizar estado visual vazio/não vazio.
     */
    const cartDrawer = document.querySelector('#CartDrawer');

    if (cartDrawer) {
      const hasRealItems = cart.items.some((item) => Number(item.variant_id) !== VOLTA_VARIANT_ID);

      cartDrawer.toggleAttribute('empty-cart', !hasRealItems);

      if (cartDrawer.hasAttribute('data-has-warning-placeholder')) {
        cartDrawer.toggleAttribute('is-empty', !hasRealItems);
      }

      if (!hasRealItems) {
        if (typeof cartDrawer.updateAsideProductsByParsedState === 'function') {
          cartDrawer.updateAsideProductsByParsedState({ quantity: 0 });
        } else {
          cartDrawer.removeAttribute('has-aside-products');
        }
      } else {
        hideRelatedProductsInCart(cart);
      }

      if (typeof cartDrawer.updateViewport === 'function') {
        cartDrawer.updateViewport();
      }
    }

    paintVoltaLine(cart);
  } catch (error) {
    console.warn('VOLTA: erro ao atualizar interface do carrinho.', error);
  } finally {
    setTimeout(() => {
      refreshingAurora = false;
      if (refreshQueued) {
        refreshQueued = false;
        refreshAuroraCartUI();
      }
    }, REFRESH_UNLOCK_DELAY);
  }
}

  async function syncVoltaDeposit() {
    if (syncing) {
      syncQueued = true;
      return false;
    }

    syncing = true;
    let changed = false;

    try {
      const cart = await getCart();
      const expectedUnits = getExpectedVoltaUnits(cart);
      const voltaLine = getVoltaLine(cart);
      const currentUnits = voltaLine ? voltaLine.quantity : 0;

      if (expectedUnits === currentUnits) {
        updateHeaderCartCount(cart);
        paintVoltaLine(cart);
      } else {
        if (expectedUnits > 0 && !voltaLine) {
          await addVoltaLine(expectedUnits);
        }

        if (voltaLine && expectedUnits !== currentUnits) {
          await changeVoltaLine(voltaLine.key, expectedUnits);
        }

        document.dispatchEvent(
          new CustomEvent('volta:updated', {
            detail: {
              expectedUnits
            }
          })
        );

        changed = true;
      }
    } catch (error) {
      console.warn(error);
    }

    syncing = false;

    if (syncQueued) {
      syncQueued = false;
      changed = (await syncVoltaDeposit()) || changed;
    }

    return changed;
  }

  function scheduleSync(delay) {
    clearTimeout(syncTimer);

    syncTimer = setTimeout(async function () {
      if (window.__packConverting) return;

      const changed = await syncVoltaDeposit();
      if (changed) {
        await refreshAuroraCartUI();
      }
    }, delay || QUICK_SYNC_DELAY);
  }

  function updateVoltaUnitsInput(form) {
    const variantInput = form.querySelector('[name="id"]');
    const voltaInput = form.querySelector('[data-volta-units-input]');
    const mapScript = form.querySelector('[data-volta-variant-map]');

    if (!variantInput || !voltaInput || !mapScript) return;

    try {
      const map = JSON.parse(mapScript.textContent);
      const variantId = variantInput.value;
      voltaInput.value = map[variantId] || 0;
    } catch (error) {
      console.warn('VOLTA: erro ao atualizar unidades da variante.', error);
    }
  }

  function observeProductForm(form) {
    if (!form || observedForms.has(form)) return;

    observedForms.add(form);
    updateVoltaUnitsInput(form);

    const variantInput = form.querySelector('[name="id"]');

    if (variantInput) {
      variantInput.addEventListener('change', function () {
        updateVoltaUnitsInput(form);
      });

      variantInput.addEventListener('input', function () {
        updateVoltaUnitsInput(form);
      });

      const observer = new MutationObserver(function () {
        updateVoltaUnitsInput(form);
      });

      observer.observe(variantInput, {
        attributes: true,
        attributeFilter: ['value']
      });
    }
  }

  function observeAllProductForms() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(observeProductForm);
  }

  /**
   * Principal: depois de o Aurora terminar o fetch do carrinho,
   * sincronizamos quase de imediato.
   */
  if (!window.__VOLTA_FETCH_PATCHED__) {
    window.__VOLTA_FETCH_PATCHED__ = true;

    const originalFetch = window.fetch.bind(window);

    window.fetch = async function patchedFetch(input, init) {
      const url = getUrlFromRequest(input);
      const isMutation = isCartMutationUrl(url);

      const response = await originalFetch(input, init);

      if (isMutation && !internalVoltaRequest) {
        scheduleSync(QUICK_SYNC_DELAY);
      }

      return response;
    };
  }

  /**
   * Fallback para XMLHttpRequest.
   */
  if (!window.__VOLTA_XHR_PATCHED__) {
    window.__VOLTA_XHR_PATCHED__ = true;

    const originalOpen = XMLHttpRequest.prototype.open;
    const originalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function patchedOpen(method, url) {
      this.__voltaUrl = url;
      return originalOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function patchedSend() {
      this.addEventListener('loadend', function () {
        if (isCartMutationUrl(this.__voltaUrl)) {
          scheduleSync(QUICK_SYNC_DELAY);
        }
      });

      return originalSend.apply(this, arguments);
    };
  }

  document.addEventListener('submit', function (event) {
    const form = event.target.closest('form[action*="/cart/add"]');
    if (!form) return;

    updateVoltaUnitsInput(form);

    /**
     * Fallback. Se o fetch patch apanhar o AJAX, ele vai cancelar este timer
     * e correr mais cedo.
     */
    scheduleSync(FALLBACK_SYNC_DELAY);
  });

  document.addEventListener('change', function (event) {
    const form = event.target.closest('form[action*="/cart/add"]');

    if (form) {
      updateVoltaUnitsInput(form);
    }

    if (
      event.target.matches('input[name="updates[]"]') ||
      event.target.closest('[data-quantity-input]') ||
      event.target.closest('quantity-component') ||
      event.target.closest('quantity-input')
    ) {
      scheduleSync(QUICK_SYNC_DELAY);
    }
  });

  document.addEventListener('click', function (event) {
    if (
      event.target.closest('[name="add"]') ||
      event.target.closest('[data-cart-update]') ||
      event.target.closest('[data-cart-remove]') ||
      event.target.closest('cart-remove-button') ||
      event.target.closest('[data-quantity-input]') ||
      event.target.closest('[data-quantity-button]') ||
      event.target.closest('quantity-btn')
    ) {
      /**
       * Fallback para casos em que o evento de carrinho do Aurora
       * não passe por fetch/XHR.
       */
      scheduleSync(FALLBACK_SYNC_DELAY);
    }
  });

  document.addEventListener(
    'click',
    async function (event) {
      const checkoutButton = event.target.closest(
        '[name="checkout"], [data-cart-checkout-button], [data-cart-page-checkout-button]'
      );

      if (!checkoutButton) return;

      event.preventDefault();
      event.stopPropagation();

      await syncVoltaDeposit();
      window.location.href = '/checkout';
    },
    true
  );

  document.addEventListener('DOMContentLoaded', function () {
    observeAllProductForms();
    scheduleSync(STARTUP_SYNC_DELAY);
  });

  const bodyObserver = new MutationObserver(function () {
    observeAllProductForms();
  });

  bodyObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  window.syncVoltaDeposit = syncVoltaDeposit;
  window.refreshVoltaCartUI = refreshAuroraCartUI;
  window.debugVoltaCart = async function () {
    const cart = await getCart();

    console.table(
      cart.items.map((item) => ({
        title: item.title,
        quantity: item.quantity,
        variant_id: item.variant_id,
        volta_units: item.properties?._volta_units || '',
        is_volta_deposit: Number(item.variant_id) === VOLTA_VARIANT_ID
      }))
    );

    return cart;
  };
})();